import {inject, Injectable} from '@angular/core';
import {injectMutation, QueryClient} from '@tanstack/angular-query-experimental';
import {lastValueFrom, map} from 'rxjs';
import {DirectDebitService, downloadFile, extractFilenameFromContentDisposition} from '../../../../api';
import {QueryKey} from '../../../constants/query-key';

@Injectable({providedIn: 'root'})
export class DirectDebitStore {
  private readonly directDebitService = inject(DirectDebitService);
  private readonly queryClient = inject(QueryClient);

  // The preview does not mark invoices as exported, so no cache invalidation on success.
  previewMutation = injectMutation(() => ({
    mutationFn: (invoiceIds: number[]) =>
      lastValueFrom(this.directDebitService.previewDirectDebit({invoiceIds}, 'response').pipe(
        map(response => {
          const filename = extractFilenameFromContentDisposition(
            response.headers.get('Content-Disposition'),
            'DirectDebitPreview.xlsx'
          );
          downloadFile(response.body!, filename);
        })
      )),
  }));

  exportMutation = injectMutation(() => ({
    mutationFn: (invoiceIds: number[]) =>
      lastValueFrom(this.directDebitService.exportDirectDebit({invoiceIds}, 'response').pipe(
        map(response => {
          const filename = extractFilenameFromContentDisposition(
            response.headers.get('Content-Disposition'),
            'DirectDebit.xml'
          );
          downloadFile(response.body!, filename);
        })
      )),
    onSuccess: () => {
      // Refresh the list so the freshly exported invoices show their export date and drop out of the next export.
      this.queryClient.invalidateQueries({queryKey: [QueryKey.INVOICES]});
    },
  }));
}
